<template>
  <div class="_product-info-content">
    <AdditionalMessageInfo v-if="showAdditionalMessageInfo" />
    <PremiumIdInfo v-if="showPremiumIdInfo" />
    <OaChatPackageInfo v-if="showOaChatPackageInfo" />
  </div>
</template>

<script>
import AdditionalMessageInfo from '@/components/ProductInfo/AdditionalMessageInfo'
import PremiumIdInfo from '@/components/ProductInfo/PremiumIdInfo'
import OaChatPackageInfo from '@/components/ProductInfo/OaChatPackageInfo'

export default {
  name: 'ProductInformationContent',
  components: {
    AdditionalMessageInfo,
    PremiumIdInfo,
    OaChatPackageInfo
  },
  props: {
    showAdditionalMessageInfo: {
      type: Boolean,
      default: true
    },
    showPremiumIdInfo: {
      type: Boolean,
      default: true
    },
    showOaChatPackageInfo: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
._product-info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  font-family: "Prompt", sans-serif;
}

/* Styles moved to individual components */
</style>
